import WmsLayer from './WmsLayer';
import { pzgikAttribution } from './attribution';

export default class GesutLayer extends WmsLayer {
    static ID = 'gesut';
    static DESCRIPTION = 'Uzbrojenie terenu z geodezyjnej ewidencji sieci uzbrojenia terenu';
    static MIN_ZOOM = 18;

    getWmsConfig() {
        return {
            url: 'https://integracja.gugik.gov.pl/cgi-bin/KrajowaIntegracjaUzbrojeniaTerenu',
            params: {
                LAYERS: 'przewod_wodociagowy,przewod_kanalizacyjny,przewod_cieplowniczy,przewod_gazowy,przewod_telekomunikacyjny,przewod_elektroenergetyczny,przewod_niezidentyfikowany,przewod_urzadzenia',
                FORMAT: 'image/png',
                TRANSPARENT: 'true',
                VERSION: '1.1.1'
            },
            opacity: 0.85,
            attribution: pzgikAttribution('geodezyjna ewidencja sieci uzbrojenia terenu')
        };
    }
}
